import React from "react";

export default function PayoutDetailSkeleton() {
    return (
        <div className="row buyProductSectionBg">
            <div className="col-md-12">
                <div className="userDetail">
                    <div className="innerDetail">

                        <div className="skeleton skeleton-title mb-3" />

                        <div className="skeleton skeleton-line mb-2" />
                        <div className="skeleton skeleton-line mb-2" />
                        <div className="skeleton skeleton-line mb-4" />

                        <div className="skeleton skeleton-paragraph mb-4" />

                        <div className="skeleton skeleton-small-title mb-2" />
                        <div className="skeleton skeleton-line mb-2" />

                        <div className="skeleton skeleton-small-title mb-2 mt-3" />
                        <div className="skeleton skeleton-line mb-2" />
                        <div className="skeleton skeleton-line short" />

                    </div>
                </div>
            </div>
        </div>
    );
}
